import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon, Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import Stock from './stock';
import Orders from './orders';
import BilledOrders from './billedOrders';
import Reservations from './reservations';

class PartInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    const {selectCode} = this.props;
    this.props.fetchStockDetail(selectCode, true);
    this.props.fetchOnOrdersDetail(selectCode, false, true);
    this.props.getPartStockReservations(selectCode);
  }

  handleClose() {
    this.props.selectDealerEmergingOrderCode('');
  }

  render() {
    const {selectCode} = this.props;

    if (!selectCode) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='12' className="overflow-datail-part">
          <Card raised fluid className='dealer-emerging-part-info'>
            <Grid>
              <Grid.Row>
                <Grid.Column width='12' textAlign='left'>
                  <h2>{selectCode}</h2>
                </Grid.Column>
                <Grid.Column width='4' textAlign='right'>
                  <Icon link name='close' size='big' color='red' onClick={this.handleClose} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='8'>
                  <BilledOrders />
                </Grid.Column>
                <Grid.Column width='8'>
                  <Reservations />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='4'>
                  <Orders />
                </Grid.Column>
                <Grid.Column width='12'>
                  <Stock />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card>
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingStockDetail,
    'stockDetail': state.partModals.stockDetail,
    'selectCode': state.dealerEmergingOrders.selectedCode,
  };
};

const {
  selectDealerEmergingOrderCode,
  fetchOnOrdersDetail,
  fetchStockDetail,
  getPartStockReservations,
} = Actions;

export default connect(mapStateToProps, {
  selectDealerEmergingOrderCode,
  fetchOnOrdersDetail,
  fetchStockDetail,
  getPartStockReservations,
})(PartInfo);
